import React, { FC } from "react"
import ReactMarkdown from "react-markdown"
import { Card } from "antd"
import css from "../AGB/AGB.module.css"

const Datenschutz: FC = () => {
    const content = `# Datenschutzerklärung

## 1. Verantwortlicher für die Datenverarbeitung

Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten im Zusammenhang mit der Kursbuchung ist die jeweilige Schwimmschule bzw. der jeweilige Kursanbieter, bei dem Sie einen Kurs buchen.

Die Kontaktdaten des Verantwortlichen finden Sie auf der Website des jeweiligen Kursanbieters.

---

## 2. Rolle der KursOrganizer GmbH

Die KursOrganizer GmbH stellt lediglich die technische Plattform zur Verfügung und verarbeitet Ihre personenbezogenen Daten ausschließlich im Auftrag des jeweiligen Kursanbieters gemäß Art. 28 DSGVO (Auftragsverarbeiter).

**KursOrganizer GmbH**  
Bulachstr. 8  
85232 Bergkirchen  
E-Mail: info@kursorganizer.com  

Die KursOrganizer GmbH trifft keine eigenen Entscheidungen über Zwecke und Mittel der Datenverarbeitung im Zusammenhang mit Ihrer Kursbuchung.

---

## 3. Welche Daten werden verarbeitet?

Folgende personenbezogene Daten werden im Rahmen der Nutzung der Plattform verarbeitet:

### 3.1 Registrierungsdaten
- Anrede, Vor- und Nachname
- E-Mail-Adresse
- Zugangsdaten: Anmeldung per zeitlich begrenztem Anmelde-Link oder mit Passwort
- Geburtsdatum (optional)
- Telefonnummer
- Adresse

### 3.2 Buchungsdaten
- Kursteilnehmer-Daten (Name, Geburtsdatum, ggf. weitere vom Kursanbieter erforderliche Angaben)
- Buchungszeitpunkt
- Gewählter Kurs
- Teilnahmevoraussetzungen (z.B. Schwimmabzeichen)

### 3.3 Zahlungsdaten
- Gewählte Zahlungsmethode
- Bei SEPA-Lastschrift: IBAN, Kontoinhaber, Mandatsreferenz
- Bei Online-Zahlung über Mollie: Betrag, Zahlungsstatus und Zahlungsreferenz. Karten- und Kontodaten geben Sie direkt bei Mollie ein; sie werden nicht auf der Plattform gespeichert.

### 3.4 Kommunikationsdaten
- E-Mail-Kommunikation mit dem Kursanbieter
- Buchungsbestätigungen
- Erinnerungen und Benachrichtigungen

### 3.5 Technische Daten
- IP-Adresse
- Browser-Typ und -Version
- Betriebssystem
- Zugriffszeitpunkte
- Ereignisse im Buchungsablauf, z. B. abgelehnte Buchungen und fehlgeschlagene Anmeldungen (ohne IP-Adresse)
- Cookies (siehe Punkt 9)

---

## 4. Rechtsgrundlagen der Datenverarbeitung

Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf folgenden Rechtsgrundlagen:

### 4.1 Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO)
Die Verarbeitung ist erforderlich zur Durchführung des Kursvertrags zwischen Ihnen und dem Kursanbieter.

### 4.2 Einwilligung (Art. 6 Abs. 1 lit. a DSGVO)
Für Newsletter, Marketing-Kommunikation und optionale Datenverarbeitungen holen wir Ihre ausdrückliche Einwilligung ein.

### 4.3 Rechtliche Verpflichtungen (Art. 6 Abs. 1 lit. c DSGVO)
Soweit gesetzliche Aufbewahrungspflichten bestehen (z.B. steuerrechtliche Aufbewahrungsfristen).

### 4.4 Berechtigte Interessen (Art. 6 Abs. 1 lit. f DSGVO)
Für technische Sicherheit, Betrugsbekämpfung und Systemstabilität sowie zur Klärung fehlgeschlagener Buchungen und Anmeldungen im Kundensupport.

---

## 5. Zwecke der Datenverarbeitung

Ihre Daten werden verarbeitet für:

- Durchführung der Kursbuchung
- Verwaltung Ihres Kundenkontos
- Kommunikation mit Ihnen
- Zahlungsabwicklung
- Versand von Buchungsbestätigungen und Erinnerungen
- Kundenservice und Support
- Erfüllung gesetzlicher Aufbewahrungspflichten
- Technische Bereitstellung und Sicherheit der Plattform

---

## 6. Weitergabe von Daten

### 6.1 Weitergabe an Dritte
Ihre Daten werden nur in folgenden Fällen an Dritte weitergegeben:

- **Kursanbieter**: Erhält alle für die Kursdurchführung notwendigen Daten
- **Hosting-Anbieter**: Für die technische Bereitstellung der Plattform
- **E-Mail-Versand**: Für den Versand von Bestätigungen und Benachrichtigungen
- **Mollie B.V. (Amsterdam, Niederlande)**: Für Online-Zahlungen, sofern der Kursanbieter sie anbietet. Mollie verarbeitet Ihre Zahlungsdaten als eigener Verantwortlicher und bewahrt sie nach eigenen gesetzlichen Pflichten auf. Datenschutzerklärung: [https://www.mollie.com/de/privacy](https://www.mollie.com/de/privacy)
- **seven communications GmbH & Co. KG (seven.io), Willestr. 4-6, 24103 Kiel**: Für den Versand von SMS, sofern der Kursanbieter SMS-Benachrichtigungen nutzt. Übermittelt werden Mobilnummer und Nachrichtentext; seven.io prüft auch die Gültigkeit der Mobilnummer. Vertragspartner von seven.io ist der Kursanbieter.

### 6.2 Keine Weitergabe für Werbezwecke
Ihre Daten werden nicht an Dritte für deren Werbezwecke weitergegeben.

### 6.3 Auftragsverarbeiter

KursOrganizer GmbH setzt folgende Auftragsverarbeiter ein, die vertraglich nach Art. 28 DSGVO verpflichtet wurden:

#### 6.3.1 Hetzner Online GmbH
**Industriestr. 25, 91710 Gunzenhausen**

- **Zweck**: E-Mail-Postfächer (u. a. für Antworten auf E-Mails der Plattform), DNS und Webhosting
- **Standort**: Rechenzentren in Deutschland
- **Zertifizierung**: ISO/IEC 27001 zertifiziert
- **Dokumentation**: [https://www.hetzner.com/de/unternehmen/zertifizierung/](https://www.hetzner.com/de/unternehmen/zertifizierung/)

#### 6.3.2 Mailjet GmbH
**Alt-Moabit 2, 10557 Berlin**

- **Zweck**: Versand von Marketing- und transaktionalen E-Mails (Buchungsbestätigungen, Erinnerungen, Rechnungen)
- **Standorte**: Server in Frankfurt am Main (Deutschland) und Saint-Ghislain (Belgien)
- **Compliance**: DSGVO-konform, SSL-Verschlüsselung, tägliches Backup
- **Dokumentation**: [https://www.mailjet.com/de/rechtliches/av-vertrag/](https://www.mailjet.com/de/rechtliches/av-vertrag/)

#### 6.3.3 DigitalOcean LLC
**105 Edgeview Drive, Suite 425, Broomfield, CO 80021, USA**

- **Zweck**: Betrieb der Plattform: Server, Datenbank, Zwischenspeicher (Valkey), Dateispeicher und das Anmeldesystem (FusionAuth, auf eigenen Servern betrieben)
- **Standort**: Frankfurt/Main (Deutschland)
- **Zertifizierung**: ISO 27001 zertifiziert
- **Auftragsverarbeitungsvertrag**: [https://www.digitalocean.com/legal/data-processing-agreement/](https://www.digitalocean.com/legal/data-processing-agreement/)
- **Datenschutz**: [https://www.digitalocean.com/legal/privacy-policy/](https://www.digitalocean.com/legal/privacy-policy/)
- **Trust & Compliance**: [https://www.digitalocean.com/trust/certification-reports](https://www.digitalocean.com/trust/certification-reports)

#### 6.3.4 Amazon Web Services (AWS) / Amazon S3
**Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, L-1855 Luxembourg**

- **Zweck**: Zentrale Speicherung von Rechnungen
- **Standort**: Frankfurt Rechenzentrum (Deutschland)
- **Zertifizierungen**: ISO 27001, 27017, 27018 und weitere
- **DSGVO-Compliance**: [https://aws.amazon.com/de/compliance/gdpr-center/](https://aws.amazon.com/de/compliance/gdpr-center/)
- **Compliance Programme**: [https://aws.amazon.com/de/compliance/programs/](https://aws.amazon.com/de/compliance/programs/)

#### 6.3.5 Sentry (Functional Software Inc.)
**Functional Software Inc., 45 Fremont Street, 8th Floor, San Francisco, CA 94105, USA**

- **Zweck**: Fehlerüberwachung (Error Monitoring) und Performance-Monitoring zur Sicherstellung der Stabilität und Funktionsfähigkeit der Plattform
- **Standort**: Rechenzentrum in Deutschland (ingest.de.sentry.io)
- **Datenverarbeitung**: IP-Adresse (anonymisiert), Browser-Typ und -Version, Betriebssystem, Fehlermeldungen, technische Diagnosedaten
- **Rechtsgrundlage**: Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) — Gewährleistung der technischen Funktionsfähigkeit und schnelle Fehlerbehebung
- **Speicherdauer**: Gemäß Sentry-Retention-Einstellungen (Standard: 90 Tage)
- **Datenschutz**: [https://sentry.io/privacy/](https://sentry.io/privacy/)
- **DSGVO-Compliance / DPA**: [https://sentry.io/legal/dpa/](https://sentry.io/legal/dpa/)

Alle Auftragsverarbeiter wurden sorgfältig ausgewählt und verpflichten sich zur Einhaltung der DSGVO. Es wurden Auftragsverarbeitungsverträge gemäß Art. 28 DSGVO abgeschlossen.

---

## 7. Speicherdauer

### 7.1 Aktive Nutzung
Solange Sie ein aktives Kundenkonto haben, werden Ihre Daten gespeichert.

### 7.2 Nach Kontolöschung
- Rechnungen, Buchungs- und Zahlungsbelege: 8 Jahre ab Ende des Kalenderjahres, in dem die Rechnung ausgestellt wurde (bei Abrechnung in Schweizer Franken 10 Jahre)
- Kommunikationsdaten: 3 Jahre für Gewährleistungsansprüche

### 7.3 Protokolle
- Server-Protokolle: 30 Tage
- Fehlerprotokolle (Sentry): bis zu 90 Tage
- Ereignisse im Buchungsablauf (z. B. abgelehnte Buchungen, fehlgeschlagene Anmeldungen): 90 Tage

### 7.4 Sicherungskopien
Regelmäßige Sicherungskopien der Datenbank werden bis zu 7 Tage aufbewahrt, Sicherungen der Server bis zu 4 Wochen. Danach werden sie automatisch überschrieben.

---

## 8. Ihre Rechte

Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:

### 8.1 Auskunftsrecht (Art. 15 DSGVO)
Sie können Auskunft über die bei uns gespeicherten Daten verlangen.

### 8.2 Berichtigungsrecht (Art. 16 DSGVO)
Sie können die Berichtigung unrichtiger Daten verlangen.

### 8.3 Löschungsrecht (Art. 17 DSGVO)
Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.

### 8.4 Einschränkung der Verarbeitung (Art. 18 DSGVO)
Sie können die Einschränkung der Verarbeitung verlangen.

### 8.5 Datenübertragbarkeit (Art. 20 DSGVO)
Sie können Ihre Daten in einem strukturierten, gängigen Format erhalten.

### 8.6 Widerspruchsrecht (Art. 21 DSGVO)
Sie können der Verarbeitung Ihrer Daten aus Gründen Ihrer besonderen Situation widersprechen.

### 8.7 Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO)
Sie können erteilte Einwilligungen jederzeit widerrufen.

### 8.8 Beschwerderecht
Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.

**Kontakt für Betroffenenrechte:**  
Bitte wenden Sie sich an den jeweiligen Kursanbieter (Verantwortlicher) oder an die KursOrganizer GmbH als technischen Dienstleister.

---

## 9. Cookies und Tracking

### 9.1 Technisch notwendige Cookies
Die Plattform verwendet technisch notwendige Cookies für:
- Aufrechterhaltung Ihrer Sitzung (Session)
- Login-Status
- Spracheinstellungen
- Sicherheitsfunktionen

Diese Cookies sind erforderlich für die Funktion der Plattform und können nicht deaktiviert werden.

### 9.2 Externe Dienste
Die Plattform bindet folgende externe Dienste ein:

- **Mailjet**: Für den Versand von transaktionalen E-Mails (Buchungsbestätigungen, Erinnerungen, Rechnungen, Anmelde-Links)
- **Hetzner Online**: Für E-Mail-Postfächer, DNS und Webhosting
- **DigitalOcean**: Für den Betrieb der Plattform einschließlich der Anmeldung
- **Amazon Web Services (AWS)**: Für die zentrale Speicherung von Rechnungen
- **Sentry**: Für Fehlerüberwachung und Performance-Monitoring zur Sicherstellung der Plattformstabilität
- **Mollie**: Für Online-Zahlungen (Weiterleitung auf die Zahlungsseite von Mollie)
- **seven.io**: Für den SMS-Versand, sofern der Kursanbieter ihn nutzt

Detaillierte Informationen zu diesen Diensten finden Sie unter Punkt 6.

---

## 10. Datensicherheit

### 10.1 Technische Maßnahmen
- **SSL/TLS-Verschlüsselung** für alle Datenübertragungen (HTTPS)
- **Anmelde-Links**: Anmeldung ohne Passwort über zeitlich begrenzte, einmalig verwendbare Links (reduziert Risiken durch Passwortdiebstahl und Phishing)
- **Passwörter** werden nicht im Klartext, sondern nur als gesalzener Hash gespeichert
- **Token-basierte Sicherheit**: Kryptografisch sichere Token für Anmeldungen
- **Verschlüsselte Speicherung** sensibler Daten
- **Tenant-Isolation**: Logische Datentrennung durch Tenant-IDs in der Datenbank
- **Zugriffsbeschränkungen** nach dem Need-to-Know-Prinzip und rollenbasierte Berechtigungen
- **Protokollierung**: Nachvollziehbarkeit von Datenbankeinträgen (Erstellung, Änderung, Löschung)
- **Monitoring**: Kontinuierliche Überwachung auf verdächtige Aktivitäten
- **Regelmäßige Sicherheitsupdates**
- **Regelmäßige Backups**

### 10.2 Organisatorische Maßnahmen
- Vertraulichkeitsverpflichtung aller Mitarbeiter
- Regelmäßige Sicherheitsüberprüfungen
- Incident-Response-Plan für Datenschutzverletzungen

---

## 11. Datenverarbeitung außerhalb der EU

Die Datenverarbeitung erfolgt grundsätzlich innerhalb der EU/EWR:

- **Hetzner Online**: Server in Deutschland
- **Mailjet**: Server in Deutschland (Frankfurt) und Belgien (Saint-Ghislain)
- **DigitalOcean**: Frankfurt Rechenzentrum (Deutschland)
- **AWS S3**: Frankfurt Rechenzentrum (Deutschland)
- **Sentry**: Rechenzentrum in Deutschland (ingest.de.sentry.io)

**Hinweis zu US-Dienstleistern**:

- **DigitalOcean**: Obwohl DigitalOcean ein US-Unternehmen ist, erfolgt die Verarbeitung Ihrer Daten ausschließlich im Rechenzentrum in Frankfurt/Main (Deutschland). Es wurde ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO abgeschlossen. DigitalOcean ist zudem nach dem EU-U.S. Data Privacy Framework zertifiziert.

- **Sentry (Functional Software Inc.)**: Sentry ist ein US-Unternehmen. Die Verarbeitung Ihrer Daten erfolgt ausschließlich im deutschen Rechenzentrum (ingest.de.sentry.io). Es werden ausschließlich technische Fehlerdaten verarbeitet — keine Marketing- oder Trackingdaten. Ein Data Processing Addendum (DPA) wurde abgeschlossen.

Sollten im Einzelfall weitere Daten in Drittländer übertragen werden, erfolgt dies nur:
- Auf Basis von Angemessenheitsbeschlüssen der EU-Kommission
- Unter Verwendung von EU-Standardvertragsklauseln
- Mit Ihrer ausdrücklichen Einwilligung

---

## 12. Automatisierte Entscheidungsfindung / Profiling

Es findet keine automatisierte Entscheidungsfindung im Sinne von Art. 22 DSGVO statt.

---

## 13. Minderjährigenschutz

Die Plattform richtet sich nicht an Kinder unter 16 Jahren. Sollten wir Kenntnis davon erhalten, dass Daten von Minderjährigen ohne Zustimmung der Erziehungsberechtigten verarbeitet wurden, werden diese Daten gelöscht.

Bei Kursen für Kinder erfolgt die Registrierung durch die Erziehungsberechtigten.

---

## 14. Änderungen dieser Datenschutzerklärung

Diese Datenschutzerklärung kann aufgrund rechtlicher oder technischer Änderungen angepasst werden. Über wesentliche Änderungen informieren wir Sie per E-Mail.

---

*Stand: 02.10.2026*
*Letzte Aktualisierung: 02.10.2026*`

    return (
        <div className={css.container}>
            <Card className={css.card}>
                <div className={css.content}>
                    <ReactMarkdown>{content}</ReactMarkdown>
                </div>
            </Card>
        </div>
    )
}

export default Datenschutz
